import React, { useEffect, useState } from 'react';
import {
    Grid,
    TextField,
    FormControlLabel,
    Switch,
    InputAdornment,
    Typography,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
} from '@mui/material';
import { Title as TitleIcon, Description as DescriptionIcon } from '@mui/icons-material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSurveyStore } from '../../surveyutilities/surveyStore';

const RatingBlockProperties = ({ questionId }) => {
    const { getQuestionById, updateQuestion, validateName } = useSurveyStore();
    const question = getQuestionById(questionId);
    const [nameError, setNameError] = useState('');
    const [localName, setLocalName] = useState(question?.name || '');


    const handleUpdate = (property, value) => {
        updateQuestion(questionId, { [property]: value });
    };

    useEffect(() => {
        setLocalName(question?.name || '');
    }, [question?.name]);
    if (!question) return <Typography color="error">Question not found</Typography>;

    const handleNameChange = (value) => {
        setLocalName(value);
        const validation = validateName(value, questionId);
        setNameError(validation.error);

        if (validation.isValid) {
            updateQuestion(questionId, { name: value });
        }
    };

    return (
        <Grid container spacing={2}>
            {/* Name */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Name (not visible to public, unique)"
                    value={localName}
                    onChange={(e) => handleNameChange(e.target.value)}
                    error={!!nameError}
                    helperText={nameError}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <VisibilityOffIcon />
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>

            {/* Title */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Question Title"
                    value={question.title || ''}
                    onChange={(e) => handleUpdate('title', e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start"><TitleIcon /></InputAdornment> }}
                />
            </Grid>

            {/* Description */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Description"
                    multiline
                    rows={2}
                    value={question.description || ''}
                    onChange={(e) => handleUpdate('description', e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start"><DescriptionIcon /></InputAdornment> }}
                />
            </Grid>

            {/* Rating Type */}
           <Grid size={{xs:12}}>
                <FormControl fullWidth size="small">
                    <InputLabel>Rating Type</InputLabel>
                    <Select
                        value={question.ratingType || 'stars'}
                        onChange={(e) => handleUpdate('ratingType', e.target.value)}
                        label="Rating Type"
                    >
                        <MenuItem value="stars">Stars</MenuItem>
                        <MenuItem value="numbers">Numbers</MenuItem>
                        <MenuItem value="scale">Scale</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            {/* Min/Max Values */}
            <Grid container>
            <Grid size={{xs:6}}>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Minimum Value"
                    value={question.minValue || 1}
                    onChange={(e) => handleUpdate('minValue', parseInt(e.target.value) || 1)}
                    inputProps={{ min: 1, max: 10 }}
                />
            </Grid>
            <Grid size={{xs:6}}>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Maximum Value"
                    value={question.maxValue || 5}
                    onChange={(e) => handleUpdate('maxValue', parseInt(e.target.value) || 5)}
                    inputProps={{ min: 2, max: 10 }}
                />
            </Grid>
            </Grid>
            {/* Labels */}
            <Grid container>
            <Grid size={{xs:6}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Minimum Label"
                    value={question.minLabel || ''}
                    onChange={(e) => handleUpdate('minLabel', e.target.value)}
                    placeholder="Poor"
                />
            </Grid>
            <Grid size={{xs:6}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Maximum Label"
                    value={question.maxLabel || ''}
                    onChange={(e) => handleUpdate('maxLabel', e.target.value)}
                    placeholder="Excellent"
                />
            </Grid>
                </Grid>
            {/* Required Switch */}
           <Grid size={{xs:12}}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={question.required || false}
                            onChange={(e) => handleUpdate('required', e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Required Question"
                />
            </Grid>

            {/* Question ID */}
           <Grid size={{xs:12}}>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="caption" gutterBottom>
                    ID: {questionId}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default RatingBlockProperties;